import { CartStorageService } from './../../../../core/services/cart-storage.service';
import {Component, Input, OnInit} from '@angular/core';
import { interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CmsService } from 'src/app/core/services/cms/cms.service';
import { DateAdapter } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-landingpage-header-child',
  templateUrl: './landingpage-header-child.component.html',
  styleUrls: ['./landingpage-header-child.component.scss']
})
export class LandingpageHeaderChildComponent implements OnInit {
  numberItemCart: number = 0;
  // used to unsubscribe from the interval, when OnDestroy is called.
  private alive: boolean;
  private interval: number;
  listHeads: any[];
  @Input() disableLogin: boolean;
  langCurrent = this.getLanguagelocalStored();
  isEnLanguage = true;
  language = localStorage.getItem('__language') || 'vi';
  languageSub: Subscription;

  constructor(
    private cartStorageService: CartStorageService,
    private toastr: ToastrService,
    private router: Router,
    private cmsService: CmsService,
    private _adapter: DateAdapter<any>,
    private translate: TranslateService,
  ) {
    this.interval = 600;
    this.alive = true;
    this.listHeads = [];
    this.languageSub = this.translate.onLangChange.subscribe(({ lang }) => {
      this.language = lang;
    });
  }

  ngOnInit() {
    // Time interval for 600ms
    interval(this.interval).pipe(takeWhile(() => this.alive)).subscribe(() => {
      this.getNumberOfItemInCart();
    });

    this.listHeaderCategory();
  }

  activateClassLanguage(lang) {
    this.langCurrent = lang;
  }
  
  getLanguagelocalStored() {
    return localStorage.getItem('__language');
  }

  setLanguagelocalStored(newLanguge: string) {
    localStorage.setItem('__language', newLanguge);
  }

  onChangeLanguage(languageSelected: string) {
    this.activateClassLanguage(languageSelected)
    this.setLanguagelocalStored(languageSelected);
    this._adapter.setLocale(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }

  checkIconLanguage(language: string) {
    if (language === 'en') {
      this.isEnLanguage = true;
    } else {
      this.isEnLanguage = false;
    }
  }
  toLogin(){
    localStorage.removeItem('SignDataValidate')
  }

  /**
   * check English Language
   */
  get isEnglish() {
      return this.language === 'en';
  }

  get isCurrentVietnamese() {
    return this.language === 'vi';
  }

  getTextMenuOptions(options) {
    if (typeof options !== 'undefined' && options !== null) {
      const txt = options !== ''? (this.isCurrentVietnamese ? options.name || '' : options.name_en || '') : '';
      return txt || '';
    }
  }

  getNumberOfItemInCart() {
    this.numberItemCart = this.cartStorageService.getNumberOfItemInCart();
  }

  navigationToListCart(numberItemCart) {
    if (numberItemCart !== 0) {
      this.router.navigate(['/digital']);
    } else {
      this.toastr.info('Chưa có Sản phẩm nào trong giỏ');
      return;
    }
  }

  backToBuyPakage() {
    this.router.navigate([""]);
  }

  listHeaderCategory() {
    this.cmsService.listCategoryHeader().subscribe(
      res => {
        if (res.data && res.data != null) {
          this.listHeads = res.data;
          // console.log('menu: ', this.listHeads);
        }
      }
    );
  }

  hyperlink(link: any, target: any) {
    // target="1" Chuyển liên kết trong tab hiện tại
    // target="2" Mở tab mới
    // target="3">Mở cửa sổ mới
    switch (target) {
      case 1:
        location.href = link;
        break;
      case 2:
        window.open(link, '_blank');
        break;
      case 3:
        window.open(link, '_blank', 'width=' + screen.availWidth + ',height=' + screen.availHeight)
        break;
      default:
        location.href = link;
        break;
    }
  }

  getCurrentNameLanguage(): string{
    switch(this.langCurrent){
      case 'vi':
        return 'Tiếng Việt';
      case 'en':
        return 'English';
      case 'zh':
        return '中国人';
      case 'es':
        return 'Español';
      default:
        return 'Tiếng Việt'
    }
  }
  isOpen: boolean = false;
}
